
(function(){
  var PAT = [{"qt":2,"pct":10},{"qt":3,"pct":15},{"qt":4,"pct":20},{"qt":5,"pct":25}];
  var TRUST = "<span class=\"kk-trust__item\"><img class=\"kk-trust__rm\" src=\"https://cdn.shopify.com/s/files/1/1022/0873/3571/files/royal-mail-uk-logo-png_seeklogo-267922.png?v=1781627582\" alt=\"Royal Mail\" width=\"30\" height=\"20\"><span>Free Shipping</span></span><span class=\"kk-trust__sep\">|</span><span class=\"kk-trust__item\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z\"></path></svg><span>30-Day Returns</span></span>";
  var NOTA = "Doesn’t fit? We’ll send you a different size.";
  var LAB_DESC = "Discounts";
  var PRECISA_TIMER = false;

  function nItens(){
    var c = document.querySelector('.drawer--cart .cart__items-count');
    return c ? (parseInt(c.textContent.replace(/[^0-9]/g,''), 10) || 0) : 0;
  }

  /* ── cronómetro (só nas lojas que ainda não o tinham) ─────────────────── */
  var CHAVE = 'kk_cart_deadline', MIN = 10, jaEsvaziou = false;
  function relogio(){
    if(!PRECISA_TIMER) return;
    var caixas = document.querySelectorAll('[data-kk-timer]');
    if(!caixas.length) return;
    var n = nItens(), p;
    if(n === 0){ sessionStorage.removeItem(CHAVE); caixas.forEach(function(c){c.hidden=true}); return; }
    p = sessionStorage.getItem(CHAVE);
    /* o prazo SEGUE o carrinho: se ja expirou nao se renova, senao a contagem
       nunca chegava a zero e o carrinho nunca se esvaziava */
    if(!p || isNaN(+p)){ p = String(Date.now() + MIN*60000); sessionStorage.setItem(CHAVE, p); }
    var falta = Math.max(0, (+p) - Date.now());
    var m = Math.floor(falta/60000), s = Math.floor((falta%60000)/1000);
    var txt = ('0'+m).slice(-2) + ':' + ('0'+s).slice(-2);
    caixas.forEach(function(c){
      var el = c.querySelector('[data-kk-timer-value]');
      if(el && el.textContent !== txt) el.textContent = txt;
      c.hidden = falta <= 0;
    });
    if(falta <= 0 && !jaEsvaziou){
      jaEsvaziou = true; sessionStorage.removeItem(CHAVE);
      fetch('/cart/clear.js',{method:'POST'}).then(function(){ location.reload(); });
    }
  }

  /* ── a marca da loja no lugar do título ──────────────────────────────────
     🔴 A versão anterior apagava o texto do título ANTES de saber se tinha
     alguma coisa para pôr no lugar. Na Noor, que ainda não tem logótipo
     nenhum, o cabeçalho da gaveta ficou em branco. Agora só se apaga depois
     de a marca estar lá dentro — e se não houver imagem usa-se o NOME da
     loja, que é sempre melhor do que um cabeçalho vazio. */
  function logoNoTitulo(){
    var t = document.querySelector('.drawer--cart .cart__title');
    if(!t || t.querySelector('.kk-cart-logo, .kk-cart-nome')) return;
    var orig = document.querySelector('[class*="logo__img"] img, .site-header__logo img');
    var src = orig && (orig.currentSrc || orig.src);
    var marca;
    if(src){
      marca = document.createElement('img');
      marca.className = 'kk-cart-logo'; marca.src = src; marca.alt = orig.alt || '';
    } else {
      var meta = document.querySelector('meta[property="og:site_name"]');
      var nome = (meta && meta.content) || '';
      if(!nome) return;                       /* sem nome nem logo: nao se mexe */
      marca = document.createElement('span');
      marca.className = 'kk-cart-nome'; marca.textContent = nome;
    }
    t.insertBefore(marca, t.firstChild);
    t.classList.add('kk-tem-marca');
    /* so agora e que o texto antigo sai */
    [].forEach.call(t.childNodes, function(n){
      if(n.nodeType === 3 && n.textContent.trim()) n.textContent = '';
    });
  }

  /* ── linha de desconto, para os temas que não trazem a da Olivia ──────── */
  function descontoProprio(){
    if(document.querySelector('.drawer--cart .kk-rabatte')) return;   /* a Olivia ja tem a sua */
    var inner = document.querySelector('.drawer--cart .cart__foot__inner');
    if(!inner || !carrinho) return;
    var d = (carrinho.cart_level_discount_applications || [])[0];
    var linha = inner.querySelector('.kk-desc');
    if(!d){ if(linha) linha.remove(); return; }
    if(!linha){
      linha = document.createElement('div');
      linha.className = 'kk-desc';
      linha.innerHTML = '<span class="kk-desc__lab"></span><span class="kk-desc__pill"></span><span class="kk-desc__val"></span>';
      var botoes = inner.querySelector('.cart__buttons-all');
      inner.insertBefore(linha, botoes || null);
    }
    var pct = d.value_type === 'percentage' ? Math.round(+d.value) : null;
    var molde = (document.querySelector('.drawer--cart .cart__price ins') || {}).textContent || '0,00';
    var pares = [
      ['.kk-desc__lab', LAB_DESC],
      ['.kk-desc__pill', pct !== null ? '\u2212' + pct + '%' : (d.title || '')],
      ['.kk-desc__val', '-' + moeda((carrinho.total_discount || 0)/100, molde)],
    ];
    pares.forEach(function(p){
      var el = linha.querySelector(p[0]);
      if(el && el.textContent !== p[1]) el.textContent = p[1];
    });
  }

  /* ── a barra de patamares ─────────────────────────────────────────────── */
  function barra(){
    var raiz = document.querySelector('[data-kk-tier]');
    if(!raiz) return;
    var n = nItens();
    if(n === 0){ raiz.hidden = true; return; }
    raiz.hidden = false;
    var feitos = PAT.filter(function(p){ return n >= p.qt; });
    var prox = PAT.find(function(p){ return n < p.qt; });
    var passo = 100 / PAT.length;
    var largura = feitos.length ? Math.min(100, feitos.length*passo) : (n / PAT[0].qt) * passo;
    var fill = raiz.querySelector('[data-kk-tier-fill]');
    if(fill) fill.style.width = largura + '%';
    raiz.querySelectorAll('.kk-tier__cp').forEach(function(cp){
      cp.classList.toggle('is-done', n >= (+cp.getAttribute('data-kk-cp')));
    });
    var msg = raiz.querySelector('[data-kk-tier-msg]');
    if(!msg) return;
    var novo = prox ? FALTAM(prox.qt - n, prox.pct) : MAXIMO(PAT[PAT.length-1].pct);
    /* comparar antes de escrever: escrever dentro do que se observa entra em
       ciclo infinito e congela o separador */
    if(msg.innerHTML !== novo) msg.innerHTML = novo;
  }
  var F1 = "You are <strong>§N§ item</strong> away from <strong>§P§% OFF</strong>", FN = "You are <strong>§N§ items</strong> away from <strong>§P§% OFF</strong>";
  var MX = "You've unlocked our biggest saving: <strong>§P§% OFF</strong>";
  function FALTAM(n, p){ return (n === 1 ? F1 : FN).split('§N§').join(n).split('§P§').join(p); }
  function MAXIMO(p){ return MX.split('§P§').join(p); }

  /* ── cada opção na sua linha ──────────────────────────────────────────── */
  function opcoes(){
    document.querySelectorAll('.drawer--cart .cart__item__selected-options').forEach(function(p){
      if(p.getAttribute('data-kk-opt')) return;
      var st = p.querySelector('strong'), sp = p.querySelector('span');
      if(!st || !sp) return;
      var rot = st.textContent.replace(/:\s*$/, '').split(/,\s+/);
      var val = sp.textContent.trim().split(/,\s+/);
      p.setAttribute('data-kk-opt','1');
      /* so se parte quando o numero de rotulos bate certo com o de valores;
         um valor com virgula la dentro faria a conta falhar */
      if(rot.length < 2 || rot.length !== val.length) return;
      p.textContent = '';
      for(var i=0;i<rot.length;i++){
        var linha = document.createElement('span'); linha.className = 'kk-opt';
        var b = document.createElement('strong'); b.textContent = rot[i] + ':';
        linha.appendChild(b); linha.appendChild(document.createTextNode(' ' + val[i]));
        p.appendChild(linha);
      }
    });
  }

  /* ── preços: TOTAL DA LINHA, não preço unitário ───────────────────────── */
  function numero(s){
    var t = String(s).replace(/[^0-9.,]/g,'');
    var temP = t.indexOf('.')>=0, temV = t.indexOf(',')>=0;
    if(temP && temV){
      var dec = t.lastIndexOf('.') > t.lastIndexOf(',') ? '.' : ',';
      t = t.split(dec === '.' ? ',' : '.').join('');
      if(dec === ',') t = t.replace(',', '.');
    } else if(temV){ t = /,\d{2}$/.test(t) ? t.replace(',', '.') : t.split(',').join(''); }
    else if(temP){ if(!/\.\d{1,2}$/.test(t)) t = t.split('.').join(''); }
    return parseFloat(t) || 0;
  }
  /* escreve no MESMO feitio do original: simbolo, lado e separadores. Assim
     serve tanto "£54.95" como "€54,95" sem se assumir nada. */
  function moeda(v, modelo){
    var m = String(modelo);
    var i = m.search(/[0-9]/), j = m.search(/[0-9][^0-9]*$/);
    var pre = i<0 ? '' : m.slice(0,i), pos = j<0 ? '' : m.slice(j+1);
    var corpo = i<0 ? m : m.slice(i, j+1);
    var dec = /,\d{2}$/.test(corpo) ? ',' : '.';
    var mil = dec === ',' ? '.' : ',';
    var p = v.toFixed(2).split('.');
    return pre + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil) + dec + p[1] + pos;
  }
  var carrinho = null, assinatura = '';

  /* 🔴🔴 A QUANTIDADE VEM SEMPRE DO ECRA, nunca do carrinho guardado.
     Medido a 13/08/2026 nas tres lojas: carregando no + quatro vezes seguidas,
     20 amostras em 20 durante 5 segundos mostravam a linha e o botao com os
     valores da quantidade ANTERIOR — com 5 unidades no contador, o preco de 4 —
     e nunca recuperavam. Duas causas, as duas aqui tratadas:
       1. pintava-se com o /cart.js guardado, que chega DEPOIS de o tema ja ter
          redesenhado a gaveta;
       2. as respostas chegam TROCADAS quando se carrega depressa, e uma resposta
          velha a aterrar depois de uma nova ficava como verdade para sempre —
          a assinatura ja estava marcada como feita e nunca mais se perguntava.
     Ele descreveu-o exactamente assim: «parece que fica com cache». */
  function qtdDe(it){
    var q = it.querySelector('.cart__quantity-field');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function assinaturaDoEcra(){
    var itens = document.querySelectorAll('.drawer--cart .cart__item');
    return [].map.call(itens, function(it){ return qtdDe(it); }).join('|') + '#' + itens.length;
  }
  /* o carrinho guardado so vale enquanto disser o MESMO que o ecra */
  function carrinhoActual(){
    if(!carrinho || !carrinho.items) return null;
    var itens = document.querySelectorAll('.drawer--cart .cart__item');
    if(carrinho.items.length !== itens.length) return null;
    for(var i=0;i<itens.length;i++){
      if(carrinho.items[i].quantity !== qtdDe(itens[i])) return null;
    }
    return carrinho;
  }
  function precos(){
    var itens = document.querySelectorAll('.drawer--cart .cart__item');
    if(!itens.length) return;
    var ass = assinaturaDoEcra();
    if(ass !== assinatura){
      assinatura = ass;
      var pedida = ass;
      fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
        /* so se aceita a resposta que ainda corresponde ao ecra */
        if(assinaturaDoEcra() !== pedida) return;
        carrinho = c; aplicar(); pastilhas(); rodape();
      });
    }
    /* pinta-se SEMPRE, mesmo sem resposta: o aplicar() ja nao depende dela */
    aplicar();
  }
  /* a caixa onde a poupanca e a pastilha vivem lado a lado. O tema redesenha a
     linha do produto a cada mudanca, por isso isto tem de saber recriar-se e
     nunca duplicar. */
  function caixaExtras(it){
    var cont = it.querySelector('.cart__item__content');
    if(!cont) return null;
    var cx = cont.querySelector('.kk-extras');
    if(!cx){ cx = document.createElement('div'); cx.className = 'kk-extras'; cont.appendChild(cx); }
    return cx;
  }
  function aplicar(){
    var c = carrinhoActual();
    document.querySelectorAll('.drawer--cart .cart__item').forEach(function(it,i){
      var d = c ? c.items[i] : null;
      var n = qtdDe(it);
      var ins = it.querySelector('.cart__price ins');
      var del = it.querySelector('.cart__price del');
      /* os UNITARIOS guardam-se a primeira vez que se ve cada elemento, e e a
         partir deles que tudo se recalcula: correr outra vez nao multiplica */
      if(ins && ins.getAttribute('data-kk-unit') === null){
        ins.setAttribute('data-kk-unit', String(numero(ins.textContent)));
        ins.setAttribute('data-kk-molde', ins.textContent.trim());
      }
      if(del && del.getAttribute('data-kk-unit') === null){
        del.setAttribute('data-kk-unit', String(numero(del.textContent)));
        del.setAttribute('data-kk-molde', del.textContent.trim());
      }
      var pago = 0;
      if(ins){
        var ui = parseFloat(ins.getAttribute('data-kk-unit')) || 0;
        /* o /cart.js e exacto e cobre descontos por LINHA, por isso usa-se
           quando concorda com o ecra; fora disso unitario x quantidade, que e
           sincrono e nunca mostra o passo de tras */
        pago = d ? d.final_line_price/100 : ui * n;
        var t = moeda(pago, ins.getAttribute('data-kk-molde'));
        if(ins.textContent.trim() !== t) ins.textContent = t;
      }
      if(del){
        var u = parseFloat(del.getAttribute('data-kk-unit')) || 0;
        var td = moeda(u * n, del.getAttribute('data-kk-molde'));
        if(del.textContent.trim() !== td) del.textContent = td;
        /* a poupanca: se o tema nao a desenha (a Noor nao desenhava), cria-se */
        var sav = it.querySelector('.kk-saving');
        var falta = (u * n) - pago;
        if(falta > 0.005){
          if(!sav){ sav = document.createElement('span'); sav.className = 'kk-saving'; }
          var cx = caixaExtras(it);
          if(cx && sav.parentNode !== cx) cx.appendChild(sav);
          var txt = POUPANCA(moeda(falta, del.getAttribute('data-kk-molde')));
          if(sav.textContent.trim() !== txt) sav.textContent = txt;
        } else if(sav){ sav.remove(); }
      }
    });
  }
  function POUPANCA(v){ return "You save §V§".split('§V§').join(v); }

  /* ── a pastilha com a percentagem ─────────────────────────────────────── */
  function pastilhas(){
    document.querySelectorAll('.drawer--cart .cart__item').forEach(function(it){
      var ins = it.querySelector('.cart__price ins'), del = it.querySelector('.cart__price del');
      var chip = it.querySelector('.kk-chip');
      if(!ins || !del){ if(chip) chip.remove(); return; }
      var a = numero(del.textContent), b = numero(ins.textContent);
      if(!(a>0) || b >= a){ if(chip) chip.remove(); return; }
      var pct = Math.round((1 - b/a) * 100);
      var txt = PASTILHA(pct);
      if(!chip){ chip = document.createElement('span'); chip.className = 'kk-chip'; }
      /* SEMPRE dentro da caixa dos extras, e SEMPRE depois da poupanca */
      var cx = caixaExtras(it);
      if(cx && chip.parentNode !== cx) cx.appendChild(chip);
      var sv = cx && cx.querySelector('.kk-saving');
      if(sv && chip.previousElementSibling !== sv) cx.appendChild(chip);
      if(chip.textContent !== txt) chip.textContent = txt;
    });
  }
  function PASTILHA(p){ return "🚀 §P§% OFF".split('§P§').join(p); }

  /* ── rodapé: nota, pastilha do desconto e o total dentro do botão ─────── */
  function rodape(){
    var inner = document.querySelector('.drawer--cart .cart__foot__inner');
    if(inner && !inner.querySelector('.kk-note')){
      var p = document.createElement('p'); p.className = 'kk-note'; p.textContent = NOTA;
      inner.insertBefore(p, inner.firstChild);
    }
    /* 14/09: a pastilha mostra o NOME do desconto tal como esta no admin
       («2 ITEMS 10% OFF»), pedido dele. Antes o JS encolhia-o para «-10%».
       O Liquid ja escreve o nome; aqui nao se toca na pastilha. */
    var lab = document.querySelector('.drawer--cart .kk-rabatte__label');
    if(lab){
      for(var i=0;i<lab.childNodes.length;i++){
        var nd = lab.childNodes[i];
        if(nd.nodeType === 3 && nd.textContent.trim()){
          if(nd.textContent.trim() !== LAB_DESC) nd.textContent = LAB_DESC + ' ';
          break;
        }
      }
    }
    var bt = document.querySelector('.drawer--cart .cart__checkout');
    if(!bt) return;
    /* 🔴 O total do botao vem da ULTIMA linha de totais, e nao do carrinho
       guardado nem da PRIMEIRA linha. Sao dois defeitos distintos, os dois
       medidos:
         · a PRIMEIRA linha e o subtotal ANTES do desconto (Noor: "Artikelen
           €159,85" com €135,88 a pagar; Olivia: £119,96 com £95,97) — foi o
           defeito corrigido de manha;
         · o CARRINHO guardado chega por fetch depois de o tema ja ter
           redesenhado a gaveta, e punha o total de 4 unidades num carrinho de 5,
           para sempre — o defeito que ele apanhou nos screenshots.
       A ultima linha e desenhada pelo SERVIDOR a cada mudanca, por isso esta
       sempre certa e e SINCRONA. Passa pelo moeda() para o tema da Noor, que
       escreve "€135,88 EUR", sair como "€135,88". */
    var linhas = document.querySelectorAll('.drawer--cart .cart__price__holder .cart__total__price');
    if(!linhas.length) linhas = document.querySelectorAll('.drawer--cart .cart__total__price');
    var ult = linhas[linhas.length - 1];
    var refIns = document.querySelector('.drawer--cart .cart__price ins');
    var molde = (refIns && (refIns.getAttribute('data-kk-molde') || refIns.textContent)) || '0,00';
    var total = '';
    var vUlt = ult ? numero(ult.textContent) : 0;
    if(vUlt > 0) total = moeda(vUlt, molde);
    else { var cc = carrinhoActual(); if(cc) total = moeda((cc.total_price || 0)/100, molde); }
    if(!total) return;
    var span = bt.querySelector('.kk-btn-total');
    if(!span){ span = document.createElement('span'); span.className = 'kk-btn-total'; bt.appendChild(span); }
    /* espaco INSEPARAVEL: um espaco normal a abrir um elemento em linha e
       comido pelo HTML e ficava "CHECKOUT• 124,85" */
    var novo = '\u00A0\u2022\u00A0' + total;
    if(span.textContent !== novo) span.textContent = novo;
  }

  /* ── a fila de promessas por baixo do botão ────────────────────────────
     Entra por JS e não pelo Liquid porque o sítio dela é DEPOIS do bloco dos
     botões, que o tema desenha e volta a desenhar. Recoloca-se em vez de se
     criar outra: o tema redesenha o rodapé a cada mudança do carrinho e duas
     filas empilhadas era o resultado garantido. */
  function filaGarantias(){
    if(!TRUST) return;
    var alvo = document.querySelector('.drawer--cart .cart__buttons-all');
    if(!alvo || !alvo.parentNode) return;
    var linha = document.querySelector('.drawer--cart .kk-trust');
    if(!linha){
      linha = document.createElement('div');
      linha.className = 'kk-trust';
      linha.innerHTML = TRUST;
    }
    if(linha.previousElementSibling !== alvo) alvo.parentNode.insertBefore(linha, alvo.nextSibling);
  }

  function tudo(){ relogio(); logoNoTitulo(); barra(); opcoes(); precos(); pastilhas(); rodape(); filaGarantias(); descontoProprio(); }
  tudo();
  var raiz = document.querySelector('cart-drawer');
  if(raiz && window.MutationObserver){
    var agendado = false;
    new MutationObserver(function(){
      if(agendado) return; agendado = true;
      requestAnimationFrame(function(){ agendado = false; tudo(); });
    }).observe(raiz, {childList:true, subtree:true, characterData:true});
  }
  document.addEventListener('theme:cart-drawer:open', tudo);
  document.addEventListener('theme:cart:change', tudo);

  /* 🔴 O observador NÃO vê mudar a quantidade.
     Medido a 16/08: numa rajada de 4 cliques no + a 45ms, uma amostra em cada
     três apanhava a linha e o botão com os valores da quantidade anterior nos
     primeiros 250ms — e depois acertava sozinha. A razão é que o tema muda o
     valor do campo por PROPRIEDADE (input.value), e isso não gera mutação: o
     MutationObserver não dispara e o pintor só acordava no relógio seguinte.
     Não é o defeito de 13/08 (esse ficava preso para sempre); é um relâmpago.
     Cura: acordar ao clique nos botões de quantidade e voltar a passar umas
     quantas vezes enquanto o tema assenta. O tudo() só escreve quando o valor
     muda, por isso repetir sai barato. */
  function acordar(){
    requestAnimationFrame(tudo);
    [60, 150, 300, 600].forEach(function(ms){ setTimeout(tudo, ms); });
  }
  document.addEventListener('click', function(e){
    var alvo = e.target && e.target.closest && e.target.closest('.drawer--cart');
    if(alvo) acordar();
  }, true);
  document.addEventListener('input', function(e){
    if(e.target && e.target.closest && e.target.closest('.drawer--cart')) acordar();
  }, true);
  setInterval(tudo, 500);
})();

